import { Box, Card } from '@mui/material'
import CalendarIcon from '~assets/icons/calendar.svg'
import { Typography } from '~sharedUI'

export const EventDateCard = ({ date }: { date: string | undefined | null }) => {
	return (
		<Card
			variant='colored'
			sx={{ padding: '20px 24px', display: 'flex', alignItems: 'center', gap: '16px', boxShadow: 0 }}
		>
			<CalendarIcon height={'48px'} width={'48px'} />
			<Box display={'flex'} flexDirection={'column'}>
				<Typography fontSize='sm' lineHeight={'32px'} fontWeight={'bold'}>Когда?</Typography>
				<Typography fontSize='sm' lineHeight={'40px'}>{date}</Typography>
			</Box>
		</Card>
	)
}
